import { ODataQuery } from "../entities/ODataQuery";
import { Paged } from "../entities/Paged";
import { Subscriber } from "../entities/Subscriber";
import { SubscriptionRequest } from "../entities/SubscriptionRequest";
import { ApiService } from "./ApiService";

export class SubscribersService {
    private readonly apiService: ApiService;

    constructor(apiService: ApiService) {
        this.apiService = apiService;
    }

    public async getSubscribers(listId: number | null, odata?: ODataQuery): Promise<Paged<Subscriber>> {
        return (await this.apiService.getOdata(`subscribers/${listId ?? ""}`, odata)) as Paged<Subscriber>;
    }

    public async getSubscriberById(subId: string): Promise<Subscriber> {
        const res = (await this.apiService.get(`subscribers/${subId}`)) as Subscriber;
        return res;
    }

    public async getSubscribersExport(listId: number | null, listName: string, odata?: ODataQuery): Promise<void> {
        await this.apiService.getFile(
            `subscribers/${listId ?? "all"}/export`,
            `${listId === null ? "all" : listName}-subscribers.csv`,
            odata
        );
    }

    public async adminUnsubscribe(request: SubscriptionRequest): Promise<unknown> {
        return await this.apiService.put(`subscribers/${request.listId}/adminUnsubscribe`, request);
    }

    public async unsubscribe(request: SubscriptionRequest): Promise<unknown> {
        return await this.apiService.put(`subscribers/${request.listId}/unsubscribe`, request);
    }

    public async subscribe(request: SubscriptionRequest, options?: Record<string, unknown>): Promise<unknown> {
        return await this.apiService.post(`subscribers/${request.listId}`, request, options);
    }
}
